import React, { useState } from 'react';

import { getTopUpCreditAmount } from '../../utils/creditGate';
import { BillingModal } from '../BillingModal';

import type { PlanningCreditRefusalDetail } from './planningCreditRefusalError';

/** The refusal under the chat's action bar, with the Add Credits / Upgrade actions that would let the run go. */
export const PlanningCreditRefusal: React.FC<{ refusal: PlanningCreditRefusalDetail }> = ({ refusal }) => {
  const [billing, setBilling] = useState<'credits' | 'plans' | null>(null);

  return (
    <div className="agent-suggestion-credit-refusal" role="alert">
      <p className="agent-suggestion-credit-refusal__message">{refusal.message}</p>
      <div className="agent-suggestion-pills">
        {refusal.add_credits !== false && (
          <button type="button" className="ai-overview-action-btn ai-overview-action-btn--add-credit"
            onClick={() => setBilling('credits')}>
            Add Credits
          </button>
        )}
        {refusal.upgrade_available && (
          <button type="button" className="ai-overview-action-btn ai-overview-action-btn--upgrade"
            onClick={() => setBilling('plans')}>
            Upgrade
          </button>
        )}
      </div>
      {billing && (
        <BillingModal
          initialView={billing}
          initialCreditAmount={billing === 'credits' ? getTopUpCreditAmount({ shortfall: refusal.shortfall }) : undefined}
          onClose={() => setBilling(null)}
        />
      )}
    </div>
  );
};
